import Log from '../logger';
const TAG = 'notify/Notify';
export default class Notify {
    constructor() {
        this.permission = '';
    }
    send(notifyMessage) {
        this.grant(() => {
            const notification = new Notification(notifyMessage.title);
        });
    }
    grant(send) {
        if (this.permission) {
            if (this.permission === 'granted' && send) {
                send();
            }
            return;
        }
        if (!('Notification' in window)) {
            Log.debug(TAG, 'Notification', 'This browser does not support desktop notification');
            return;
        }
        else if (Notification.permission === 'granted') {
            this.permission = 'granted';
            if (send) {
                send();
            }
            return;
            // } else if (Notification.permission !== 'denied') {
            // 强制重新申请
        }
        else {
            Notification.requestPermission((permission) => {
                this.permission = permission === 'default' ? '' : permission;
                if (permission === 'granted' && send) {
                    send();
                }
            });
        }
    }
}
